export const DEFAULT_COMPONENT_STRINGS = {
    genericErrorHeader: 'Sorry, something went wrong',
    genericErrorContent: 'We encountered an error showing this page.',
};
